import { values } from './enums'

const SnapshotDateMonthly = {
  FROM_START: 0,
  TILL_END: 1,
  DAY_OF_MONTH: 2
}

const VALUES = values(SnapshotDateMonthly)

export {
  SnapshotDateMonthly,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/SnapshotDateMonthly.js